import { AlertCircle } from 'lucide-react'

type ErrorAlertProps = {
  title?: string
  message: string
  onRetry?: () => void
  onRetryLabel?: string
}

export default function ErrorMessage({ title, message, onRetry, onRetryLabel = 'Retry' }: ErrorAlertProps) {
  return (
    <div className='flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-sm'>
      <AlertCircle className='h-5 w-5 text-red-500' />
      <div className='flex-1'>
        {title && <h3 className='mb-1 font-semibold text-red-700'>{title}</h3>}
        {message && <p className='text-red-600'>{message}</p>}
        {onRetry && (
          <button onClick={onRetry} className='mt-2 text-xs font-medium text-red-700 hover:underline'>
            {onRetryLabel}
          </button>
        )}
      </div>
    </div>
  )
}
